import type { GetStaticProps, NextPage } from "next";
import Head from "next/head";
import styles from "../styles/commonStyles.module.css";
import React from "react";
import Layout from "components/Layout";
import { serverSideTranslations } from "next-i18next/pages/serverSideTranslations";

const Terms: NextPage<any> = (props: {
  locale: string;
}) => {
  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      <Head>
        <title>ZenClass - Terms and Conditions</title>
        <meta
          name="description"
          content="Teach your way - The adaptive learning platform that makes education brilliant"
        />
        <link rel="icon" href="/favicon.ico" />

        <meta property="og:title" content="ZenClass - Teach Your Way" />
        <meta property="og:image" content="https://zenclass.co/v3/logo.jpg" />
        <meta
          property="og:description"
          content="Teach your way - The adaptive learning platform that makes education brilliant"
        />

        <meta name="twitter:title" content="ZenClass - Teach Your Way" />
        <meta name="twitter:image" content="https://zenclass.co/v3/logo.jpg" />
        <meta
          name="twitter:description"
          content="Teach your way - The adaptive learning platform that makes education brilliant"
        />
      </Head>
      <Layout activeHeader={true} locale={props.locale}>
        <div style={{ padding: "36px 0" }}>
          <embed
            className={styles.iframe}
            src="https://drive.google.com/file/d/1aIpTBWd-xhaGr1gB_kIxsi12y_crzshu/preview"
          />
        </div>
      </Layout>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: {
      ...(await serverSideTranslations(ctx.locale ?? 'en', ['common'])),
      locale: ctx.locale,
    },
  };
};

export default Terms;
